import * as React from "react";
export var ChangeAmountProductsContext = React.createContext({
  maxProductsPerCategory: 2
});
ChangeAmountProductsContext.displayName = "ChangeAmountProductsContext";